import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cmp-login',
  template: `<div class="login-page icon">
  <!-- LOGIN FORM -->
  <div class="login-container">
    <div class="login">
      <div class="logo">
        <img src="./assets/images/brand/logotype_blueliv_black.svg"/>
        <p class="beta pull-left">v{{version}}</p>
      </div>
      <div>
        <ng-content select="[sm]"></ng-content>
      </div>
    </div>
  </div>
</div>
`,
  styles: [`.login-page.icon{background:url(assets/images/bglogin2.jpg) center center/cover no-repeat fixed;height:100vh!important}.login-page .login-container{padding-top:200px;margin-right:20px;margin-left:20px}.login-page .container-terms{margin-top:100px;margin-bottom:150px}.login-page .login{background-color:#fff;border-radius:4px;padding:20px;max-width:450px;margin:auto;font-family:'Open Sans',sans-serif!important;font-weight:200}.login-page .login .logo{width:150px;margin-bottom:40px}.login-page .login .beta{position:relative;top:-2px;left:126px;font-size:12px}.login-page .login .alert{margin-top:40px;margin-bottom:30px;padding-top:20px;padding-bottom:20px}.login-page .login .alert i{margin-right:5px;color:#dc665a}.login-page .login .alert p{margin-top:2px;color:#dc665a}.login-page .login label{margin-bottom:0;font-weight:400;color:#1b2734}.login-page .login .text-input{width:100%;margin-bottom:15px;border-radius:2px;padding:5px;color:#4e5761}.login-page .login button{padding-left:50px;padding-right:50px}.login-page .login .link{margin-top:8px;font-weight:200;color:#327abd;cursor:pointer}.login-page .imput-box{position:relative}.login-page .imput-box i{position:absolute;top:9px;right:10px}.login-page .captcha{margin-left:55px}.login-page body{margin:0!important;padding:0!important}.login-page button[disabled]{cursor:not-allowed}`]
})
export class LoginComponent implements OnInit {

  @Input() version;

  constructor() {
  }

  ngOnInit() {
  }

}
